import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHNivelGet = async (credentials, data) => {
    const body = {
        service: "RNHNivelGet",
        params: {
            rnhNivelId: data?.nivelId || null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
